export const OPEN_POPUP = "account/OPEN_ACCOUNT_POPUP";

export const CLOSE_POPUP = "account/CLOSE_ACCOUNT_POPUP";

export const SET_CURRENT_SCREEN_TYPE = "account/SET_CURRENT_SCREEN_TYPE";

export const LOGIN_USER = "account/LOGIN_USER";

export const LOGOUT_USER = "account/LOGOUT_USER";

export const SHOW_ACCOUNT_ICON = "account/SHOW_ACCOUNT_ICON";
